// The text a brand's buttons get, worked out live in the Branding form. The
// same rule as BrandPalette#contrast and #contrast_ratio (Ruby), which is what
// actually renders: dark text on light solids (OKLab lightness ≥ 0.8, where
// Radix's own amber, yellow, lime, mint and sky switch), white otherwise.

const DARK_TEXT = "#1c2024";
const LIGHT_TEXT = "#ffffff";
const DARK_TEXT_LIGHTNESS = 0.8;

function linear(hex: string): [number, number, number] {
  const channels = hex.replace("#", "").match(/../g)!.map((pair) => parseInt(pair, 16) / 255);
  return channels.map((c) => (c <= 0.04045 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4)) as [number, number, number];
}

function oklabLightness(hex: string) {
  const [r, g, b] = linear(hex);
  const l = Math.cbrt(0.4122214708 * r + 0.5363325363 * g + 0.0514459929 * b);
  const m = Math.cbrt(0.2119034982 * r + 0.6806995451 * g + 0.1073969566 * b);
  const s = Math.cbrt(0.0883024619 * r + 0.2817188376 * g + 0.6299787005 * b);
  return 0.2104542553 * l + 0.793617785 * m - 0.0040720468 * s;
}

function luminance(hex: string) {
  const [r, g, b] = linear(hex);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

/** The button text colour on `solid`, and its WCAG contrast. Under 3 is hard to read. */
export function buttonText(solid: string) {
  const text = oklabLightness(solid) >= DARK_TEXT_LIGHTNESS ? DARK_TEXT : LIGHT_TEXT;
  const [lighter, darker] = [luminance(solid), luminance(text)].sort((a, b) => b - a);
  return { text, ratio: Math.round(((lighter + 0.05) / (darker + 0.05)) * 100) / 100 };
}
